// extracted by mini-css-extract-plugin
export default {"wrapperPanel":"cff72598426a4f736deaf0a28b500cf2","wrapper":"_70a536ecda585bf2fc66808c5969d26c"};